export default __webpack_public_path__ + "img/i-nav-description.67bd1e19.svg";